import React from 'react'

const TagIcon = ({width=11, height=11, fill="#CE181E"}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 11 11" fill={fill} xmlns="http://www.w3.org/2000/svg">
<path d="M10.414 5.49656L4.91402 0.0015564H-0.000976562V4.91656L5.49402 10.4116L10.414 5.49656ZM1.74902 2.50156C1.33402 2.50156 0.999023 2.16656 0.999023 1.75156C0.999023 1.33656 1.33402 1.00156 1.74902 1.00156C2.16402 1.00156 2.49902 1.33656 2.49902 1.75156C2.49902 2.16656 2.16402 2.50156 1.74902 2.50156Z" fill={fill}/>
</svg>

  )
}

export default TagIcon